import { React, useEffect } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  ContentMiddle,
} from "../../styledElements";
import { Button, PageHeader } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { useLocation, useNavigate } from "react-router-dom";
import LottieAnimation from "../../../Lottie";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
import { uploadCustomers } from "../../../Services/uploadServices";
import axios from "axios";

const PreparingUploadCustomer = (props) => {
  const history = useNavigate();
  const location = useLocation();
  const source = axios.CancelToken.source();

  useEffect( () => {
    ( async () => {
    let body = {
      bucket_key: location.state.action,
    }

    await uploadCustomers(body,source)
      .then((response) => {
        if(response?.data?.customers?.length == 0){
          history("../customer-records/upload-customers", {
            state: { isFileEmpty: true, msg: "NO DATA", fileEmptyKey: "no data"}
          })
        } else{
        history("../customer-records/validate-customers", {
          state: { action: response,filename:location.state.action }
        })
      }
      })
      .catch((error) => {
        history("../customer-records/upload-customers", {
          state: { error: true }
        })
      });
    })();
  }, [])
  useEffect(() => {
    return()=>{
      source.cancel("Page is redirected")
    }
  },[])
  return (
    <RightLayoutContainer>
      <PageTitleComp style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          title="Upload Customers"
          extra={[
            <Button key="1" className="textTypeBtn textBtnIcon" onClick={() => { history("../customer-records/upload-customers") }}>
              {" "}
              <Iconmoon
                icon="wrong"
                size={14}
                color="#EA4E2C"
                style={{ marginRight: "8px", top: "1px", position: "relative" }}
              />{" "}
              Cancel Upload
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <ContentMiddle>
        <div className="imageAnimate">
          <div className="imageCover">
            <LottieAnimation lotti={JobcardPrepare} />

            <p>
              We are uploading your Customers, <br />
              please wait, it will take less than a minute
            </p>
          </div>
        </div>
      </ContentMiddle>
    </RightLayoutContainer>
  );
};

export default PreparingUploadCustomer;
